import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-screen-strobe-form',
  templateUrl: `./screen-strobe-form.component.html`,
  styleUrls: [`../smart-color/smart-color-form.component.css`]
})
export class ScreenStrobeFormComponent {
  @Output()
  submitForm = new EventEmitter();

  @Output()
  deleteColor = new EventEmitter();

  @Output()
  cancel = new EventEmitter();

  @Input()
  colors: string[] = [];

  @Input()
  index: number;

  @Input()
  editingSolidColor: boolean;
}